module.exports = __webpack_public_path__ + "media/asset/images/1_KV/ITRI_cover_SP_JP-459e83693c12877bfddf3d863a52e0da.png";